import { render, staticRenderFns } from "./FindPassword.vue?vue&type=template&id=2a4f99ff&"
import script from "./FindPassword.vue?vue&type=script&lang=js&"
export * from "./FindPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports